import React, { useState } from 'react';
import './PageHeader.css'
import './AddForm.css'
import Btn from './Btn';
import { supabase } from '../../supabase';


const PageHeader = (props) => {
    const [form, showForm] = useState(false);
    const [eventName, setEventName] = useState("")
    const [eventDate, setEventDate] = useState("")
    const [eventLoc, setEventLoc] = useState("")
    const [eventTickets, setEventTickets] = useState("")

    const AddFormHandler = () => {
        showForm(prev => !prev);
    }

    const createEvent = async () => {
        const res = await supabase.from("Events").insert([{
            'event_Name':eventName,
            'event_Date':eventDate,
            'event_Loc':eventLoc,
            'tickets_Sold': eventTickets,
            'status':'Active'
        }])

        console.log(res)
    }

    return ( 
        <>
        <div className={props.PageHeaderStyle}>
            <div className='HeaderText'>
                <p className='HeaderTitle'>
                    {props.HeaderTitle}
                </p>
                <p className='HeaderSub'>
                    {props.HeaderSub}
                </p>
            </div>

            <Btn onClick={AddFormHandler} BtnStyle="AddBtn" BtnText={props.BtnText}/>
        </div>
        <div className={form ? 'AddFormShown' : 'AddForm'}>
            <p className='FormName'>
                {props.FormName}
            </p>

            <form>
                <div className='Input'>
                    <label>Event name</label>
                    <input type="text" onChange={(e) => setEventName(e.target.value)} />
                </div>
                <div className='Input'>
                    <label>Event Date</label>
                    <input type="Date" onChange={(e) => setEventDate(e.target.value)}/>
                </div>
                <div className='Input'>
                    <label>Event Location</label>
                    <input type="text" onChange={(e) => setEventLoc(e.target.value)}/>
                </div>
                <div className='Input'>
                    <label>Event Tickets</label>
                    <input type="text" onChange={(e) => setEventTickets(e.target.value)}/>
                </div>
            </form>
            <div className='FormBtns'>
                <Btn BtnStyle="FormAddBtn" BtnText="Add Event" onClick={createEvent}/>
                <Btn BtnStyle="FormCancelBtn" BtnText="Cancel" onClick={() => showForm(false)}/>
            </div>
        </div>
        </>
     );
}
 
export default PageHeader;